import React from 'react';
import PropTypes from 'prop-types';
import { StyledModalButton } from './style';

const ModalButton = ({ children }) => (
  <StyledModalButton>{children}</StyledModalButton>
);

ModalButton.propTypes = {
  children: PropTypes.node
};

export default ModalButton;
